import {
  ArrowRight,
  HelpCircle,
  Sparkles,
} from "lucide-react";
import { Link } from "react-router-dom";
import { useConfig } from "../lib/useConfig";

export function HomePage() {
  const config = useConfig();
  return <MemoryMediaVaultAccessPage supportEmail={config?.supportEmail} />;
}

function MemoryMediaVaultAccessPage({ supportEmail }: { supportEmail?: string }) {
  return (
    <main>
      <section className="relative overflow-hidden px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-ktd-gold to-transparent" />
        <div className="mx-auto max-w-5xl text-center">
          <p className="ornament inline-flex text-xs font-extrabold uppercase tracking-[0.24em] text-ktd-softGold">
            Kreatethedate Memory Media Vault
          </p>
          <h1 className="mt-6 font-display text-5xl font-bold leading-tight text-white sm:text-6xl">
            Welcome to the Memory Media Vault
          </h1>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-8 text-white/72">
            A private place to collect, review, organize, and preserve event photos and videos.
          </p>
          <p className="mx-auto mt-5 max-w-3xl leading-7 text-white/62">
            Guests and clients can upload memories, and approved items can be shared in the Vault Gallery after review.
          </p>
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/login"
              className="focus-ring inline-flex items-center justify-center gap-2 rounded-full bg-ktd-gold px-6 py-4 text-sm font-extrabold text-ktd-black shadow-gold transition hover:bg-ktd-softGold"
            >
              Client Login <ArrowRight className="size-4" aria-hidden="true" />
            </Link>
            <Link
              to="/admin/login"
              className="focus-ring inline-flex items-center justify-center gap-2 rounded-full border border-ktd-gold/45 px-6 py-4 text-sm font-extrabold text-ktd-softGold transition hover:bg-white/8"
            >
              Admin Login
            </Link>
          </div>
        </div>
      </section>

      <section className="px-4 pb-16 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-5xl gap-6 lg:grid-cols-[1fr_.9fr]">
          <article className="rounded-lg border border-ktd-gold/25 bg-ktd-ivory p-6 text-ktd-rich shadow-luxe sm:p-8">
            <Sparkles className="size-9 text-[#8a6c14]" />
            <h2 className="mt-5 font-display text-3xl font-bold">How it works</h2>
            <p className="mt-4 text-lg font-semibold leading-8 text-ktd-rich">
              Upload memories &rarr; Review pending uploads &rarr; Approve favorites &rarr; View the Vault Gallery
            </p>
            <p className="mt-4 text-sm leading-6 text-ktd-muted">
              Uploaded media may be reviewed before appearing in the approved gallery.
            </p>
          </article>
          <article className="luxe-card rounded-lg p-6 text-white sm:p-8">
            <HelpCircle className="size-9 text-ktd-softGold" />
            <h2 className="mt-5 font-display text-3xl font-bold">Need help?</h2>
            <p className="mt-4 leading-7 text-white/68">
              Contact Kreatethedate support if you need help finding a client login, guest upload link, or public Vault Gallery.
            </p>
            {supportEmail && (
              <a
                href={`mailto:${supportEmail}`}
                className="focus-ring mt-6 inline-flex rounded-full border border-ktd-gold/45 px-5 py-3 text-sm font-extrabold text-ktd-softGold"
              >
                Contact Support
              </a>
            )}
          </article>
        </div>
      </section>
    </main>
  );
}
